
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'
import {THREE} from '../../utils/three.js'
import {getBounds} from '../../utils/dom/pos.js'

const LOADER = new THREE.ObjectLoader()

export default {

    /*data()
    {
        return {
            width: 1920,
            height: 1080
        }
    },*/

    props: {
        moveY: { type: Number, default: 0 },
        pause: { type: Boolean, default: false }
    },

    created()
    {
        // 3D
        this._ratio = 1920 / 1080

        this._camDecalZ
        this._camDecalY

        this._camera
        this._scene
        this._renderer

        this._top = 0
        this._left = 0
        this._width = 1920
        this._height = 1080
        this._scrollY = 0

        this._decalY = 0
        this._zoom = 0
        this._rot = 0
        this._rotCurrent = 0
    },

    mounted()
    {
        // EVENTS
        this._onScroll = this._onScroll.bind(this)
        this._onResize = this._onResize.bind(this)
        this._enterFrame = this._enterFrame.bind(this)
        this._onMouseMove = this._onMouseMove.bind(this)


        this.eventHub.$on('window:resized', this._onResize)
        this.eventHub.$on('enterFrame', this._enterFrame)
        this.$root.$children[0].scroll.addOnSmoothScroll(this._onScroll)
        window.addEventListener('mousemove', this._onMouseMove, false)

        // 3D
        this._loadModel()
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResize)
        this.eventHub.$off('enterFrame', this._enterFrame)
        this.$root.$children[0].scroll.removeOnSmoothScroll(this._onScroll)
        window.removeEventListener('mousemove', this._onMouseMove)
    },

    methods: {

        /*
                ┌─────────────────────────────────────────────
                │
                │       INIT 3D
                │
                └─────────────────────────────────────────────
        */

        _init3D()
        {
            const canvas = this.$el

            this._renderer = new THREE.WebGLRenderer({
                canvas,
                //stencil: false,
                //depth: false
            })

            // this._renderer.setSize(1920, 1080)
            // this._renderer.sortObjects = false
            this._renderer.setPixelRatio( window.devicePixelRatio )
            this._onResize()
        },

        _loadModel()
        {
            LOADER.load( '/assets/3d/scene-02.json', ( data ) => {

                this._scene = data;
                this._camera = this._getChild('cam', data)
                this._ratio = this._camera.aspect

                this.meshs = this._getChilds('obj', data)
                this._camDecalZ = this._camera.position.y
                this._camDecalX = this._camera.position.x
                this._camDecalY = this._camera.position.z

                for(const mesh of this.meshs)
                {
                    mesh.material.color.setHex( 0xf6f9ef )
                    // mesh.material.wireframe = true
                }


                const textLoader = new THREE.TextureLoader();
                textLoader.load('/assets/3d/scene-02-diff.png', texture => {

                    for(const mesh of this.meshs)
                    // for(let i = 0, l = this.meshs.length; i < l; i++)
                    {
                        // const mesh = this.meshs[i]
                        mesh.renderOrder = parseInt(mesh.name.split('.')[1])


                        const mat = mesh.material
                        mat.color.setHex(0xFFFFFF)
                        mat.transparent = true
                        // mat.alphaTest = 0
                        mat.depthTest = true
                        // mat.depthWrite = false
                        mat.map = texture;
                        mat.needsUpdate = true;
                        // mat.wireframe = true
                    }

                    this.$emit('load')
                    this._renderer.render( this._scene, this._camera )
                })

                this._init3D()
            })
        },

        _getChilds( name, container )
        {
            const list = []
            const children = container.children;
            for(let i = 0; i < children.length; i++)
            {
                const child = children[i]
                if (child.name.indexOf(name) > -1) {
                    list.push(child)
                }

                list.push(...this._getChilds(name, child))
            }
            return list
        },

        _getChild( name, container )
        {
            const children = container.children;
            for(let i = 0; i < children.length; i++)
            {
                const child = children[i]
                if (child.name == name) {
                    return child;
                }

                const subChild = this._getChild(name, child)
                if (subChild !== false) {
                    return subChild
                }
            }
            return false
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       EVENTS
                │
                └─────────────────────────────────────────────
        */

        _enterFrame( dt )
        {
            if (!this.pause && this._renderer && this._decalY >= 0 && this._decalY <= 1)
            {
                /*this._camera.position.y += ((this._camDecalZ - (this._zoom * 0.7)) - this._camera.position.y) * 0.05
                this._camera.position.x = this._camDecalX + (this._decalY - 0.5) * 0.6
                this._camera.position.z = this._camDecalY + (this._decalY - 0.5) * 0.06
                this._renderer.render( this._scene, this._camera )*/



                const pos = this._camera.position

                this._rotCurrent += (this._rot - this._rotCurrent) * 0.05

                pos.x = this._camDecalX + (this._decalY * 2 - 1.5) * 0.5 + this._rotCurrent * 0.5
                pos.y = this._camDecalZ - this._decalY
                pos.z += ((this._camDecalY + (this._zoom) * 1) - pos.z) * 0.05

                /*
                pos.y = this._camDecalZ
                pos.x = this._camDecalX + this._tempX * 2 - 1.5
                pos.z = this._camDecalY + this._tempY * 3 - 1.5
                */



                // width, height, depth
                this._camera.lookAt(new THREE.Vector3(0, 2, -7))
                this._renderer.render( this._scene, this._camera )
            }
        },

        _onScroll( y )
        {
            this._scroll(y)
        },

        _scroll( y = this._scrollY )
        {
            this._decalY = (y + this.$root.$children[0].windowSize[1] - this._top) / (this._height + this.$root.$children[0].windowSize[1])


            this._scrollY = y
        },

        _onMouseMove(evt)
        {
            const mouseX = (evt.clientX - this._left) / this._width
            const mouseY = ((evt.clientY + this._scrollY) - this._top) / this._height

            if (mouseX <= 0 || mouseX >= 1 || mouseY <= 0 || mouseY >= 1)
            {
                this._zoom = 0
                this._rot = 0
            }
            else
            {
                this._zoom = (1 - Math.pow(mouseX * 2 - 1, 2)) * (1 - Math.pow(mouseY * 2 - 1, 2))
                this._rot = mouseX - 0.5
            }
        },

        _onResize(evt = null)
        {
            const wMax = Math.min(this.$root.$children[0].windowSize[0] * 0.8, 1170)
            const hMax = this.$root.$children[0].windowSize[0] * 0.7

            const w = Math.min(wMax - 100, (hMax - 100) * this._ratio)
            const h = Math.min(hMax - 100, (wMax - 100) / this._ratio)

            if (this._renderer)
            {
                this._renderer.setSize(w, h)
            }

            const bounds = getBounds(this.$el)
            this._top = bounds.y // - this._scrollY
            this._left = bounds.x
            this._width = w
            this._height = h

            this._scroll()
        },
    }

}